import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {
    Button,
    CircularProgress
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import VehiculoForm from './Forms/VehiculoForm';
import TitularForm from './Forms/TitularForm';
import CoberturaForm from './Forms/CoberturaForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import axios from 'axios';
import {useAuth0} from "@auth0/auth0-react";


import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import car_white_icon from "../../../../../assets/images/white_car_icon.png";
import CotizarContext from "../../../../../context/CotizarContext";
import DiscountsContext from "../../../../../context/DiscountsContext";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";
import moment from "moment";
import handleJeepCase from "../../../../../context/products/AutomotorContext/services/handleJeepCase";

const steps = ['Vehículo', 'Titular', 'Cobertura'];
const {formId, formField} = formModel;


function _renderStepContent(step, marcas, setMarcas, modelos, setModelos, anios, setAnios, cotizacionRetomada, vehicleDetails, cotizacionResponse, setDescuentoEspecial) {
    switch (step) {
        case 0:
            return <VehiculoForm
                    cotizacionRetomada={cotizacionRetomada}
                    vehicleDetails={vehicleDetails}
                    formField={formField}/>;
        case 1:
            return <TitularForm formField={formField} cotizacionRetomada={cotizacionRetomada}/>;
        case 2:
            return <CoberturaForm
                        cotizacionRetomada={cotizacionRetomada}
                        formField={formField}
                        cotizacionResponse={cotizacionResponse}
                        setDescuentoEspecial={setDescuentoEspecial}
                    />;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutCotizar(props) {
    const cotizacionRetomada = props.cotizacionRetomada; //Indicates if it's a new quote or it isn't
    const nuevoFormInitialValues = props.cotizacionValues;
    const action = props.action;
    const vehicleDetails = useRef({
        detalle_marca: "",
        detalle_modelo: "",
        detalle_version: ""
    });

    let nuevoInitialValues;
    if (cotizacionRetomada) {
        if (nuevoFormInitialValues.TieneGNC === "true")
            nuevoFormInitialValues.TieneGNC = "0"

        //Si la fecha de hoy es despues de la fecha cotización
        if (moment(moment().format('YYYY-MM-DD')).isAfter(nuevoFormInitialValues['FechaCotizacion']))
            nuevoFormInitialValues['FechaCotizacion'] = moment().format('YYYY-MM-DD');


        vehicleDetails.current = {
            detalle_marca: nuevoFormInitialValues.DetalleMarca,
            detalle_modelo: nuevoFormInitialValues.DetalleModelo,
            detalle_version: nuevoFormInitialValues.DetalleVersion
        }

        nuevoInitialValues = {
            vehiculo: {
                'marca': parseInt(nuevoFormInitialValues.Marca),
                'anio': nuevoFormInitialValues.Anio,
                'modelo': nuevoFormInitialValues.Modelo,
                'version': nuevoFormInitialValues.Version,
                "modeloCodigo": nuevoFormInitialValues.Modelo,
                "valorAdicional": parseInt(nuevoFormInitialValues.ValorAdicional),
                "usoVehiculo": nuevoFormInitialValues.UsoVehiculo,
                "ceroKm": nuevoFormInitialValues.CeroKm.toString(),
                "tieneGnc": nuevoFormInitialValues.TieneGNC,
                "valorGnc": nuevoFormInitialValues.ValorGNC,
                "detalle_marca": nuevoFormInitialValues.DetalleMarca,
                "detalle_modelo": nuevoFormInitialValues.DetalleModelo,
                "detalle_version": nuevoFormInitialValues.DetalleVersion,
                "sumaAsegurada": nuevoFormInitialValues['SumaAsegurada'],
            },
            "situacionImpositiva": nuevoFormInitialValues.SituacionImpositiva,
            "personaJuridica": nuevoFormInitialValues.PersonaJuridica.toString(),
            "codigosLocalidad": nuevoFormInitialValues.CodigoPostal?.toString() + ',' + nuevoFormInitialValues.Localidad?.toString(),
            "vigencia": nuevoFormInitialValues.Vigencia,
            "fechaVigencia": nuevoFormInitialValues.FechaCotizacion,
            "descuentoCliente": nuevoFormInitialValues.DescuentoCliente,
            "descuentoEspecial": nuevoFormInitialValues.DescuentoEspecial,
            "descuentoExtra": nuevoFormInitialValues.DescuentoExtra,
            "frecuenciaPago": nuevoFormInitialValues.FrecuenciaPago,
            "cuotas": nuevoFormInitialValues.Cuotas,
            "ajusteAutomatico": nuevoFormInitialValues.AjusteAutomatico,
            "equipoTelematica": "",
            "comments": nuevoFormInitialValues.Comentarios,
            "carProdSelected": nuevoFormInitialValues.ProdAutoSeleccionado,
            "idCotizar": nuevoFormInitialValues.idCotizacion,
            "afinidad": nuevoFormInitialValues.idAfinidad.toString(),
            "archivos": nuevoFormInitialValues['ArchivosDePrecotizacion'],
            "fechaCotizacion": nuevoFormInitialValues['FechaCotizacion'],
        }
        if (nuevoFormInitialValues['Clientes'] !== null) {
            nuevoInitialValues = {
                ...nuevoInitialValues,
                "nombre": nuevoFormInitialValues['Clientes']['Nombre'],
                "apellido": nuevoFormInitialValues['Clientes']['Apellido'],
                "dni": nuevoFormInitialValues['Clientes']['DNI'],
                "email": nuevoFormInitialValues['Clientes']['Email'],
                "patente": nuevoFormInitialValues['Clientes']['Patente'],
                "telefono": nuevoFormInitialValues['Clientes']['Telefono'],
            }
        }
    }

    const handlerEndCotizacion = props.handlerEndCotizacion;
    const setIsCotizarDone = props.setIsCotizarDone;
    const setIsCotizando = props.setIsCotizando;
    const [isCotizarDone2, setIsCotizarDone2] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(action === 'emitir' ? steps.length-1 : 0);

    const currentValidationSchema = validationSchema[activeStep];
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const {getIdTokenClaims} = useAuth0();

    const [marcas, setMarcas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [anios, setAnios] = useState([]);

    const [saved, setSaved] = useState(false)


    const {afinidadesPic} = useContext(CotizarContext)
    const {discounts} = useContext(DiscountsContext)
    const {handleModified} = useContext(IndicatorsContext)

    async function _submitForm(values, actions) {
        setIsCotizarDone2(false)
        setIsCotizando(true)

        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;
        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar';

        if (values.vigencia === '1') // Vigencia Anual
            values.frecuenciaPago = '5';    // Frecuencia Mensual
        else
            values.frecuenciaPago = '7';    // Frecuencia Cuotas

        afinidadesPic.map(af => {
            if (af.id === values.afinidad) {
                values.img_afinidad = af.pic;
            }
        })

        setFinalValues(values);
        values.origen = "affinity"

        if (cotizacionRetomada) {
            values.is_precotizar = 'true'
            if (nuevoFormInitialValues.Modelo === values.vehiculo.modelo)
                values.modelo = values.modeloCodigo
            else
                values.modeloCodigo = values.modelo
        }

        values.descuentoEspecial = 0;

        let data = saved ?
            {
                saveToDatabase: true,
                idCotizar: cotizacionResponse['cotizacionId'],
                modeloCodigo: values.modelo,
                is_saved: saved
            } :
            {saveToDatabase: true}

        setIsCotizarDone(false)

        values.vehiculo = {
            ...values.vehiculo,
            ...vehicleDetails?.current
        }

        const jsonData = {...values, ...data};
        jsonData.vehiculo.marca = handleJeepCase(values.vehiculo.marca)

        axios.post(url, jsonData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${id_token}`,
            }
        }).then(res => {
            setCotizacionResponse(res.data);
            if (!saved) {
                values.sumaAseguradaFirst = res.data['vehicleValuation']
                handleModified()
            }
            values.vehiculo.sumaAsegurada = res.data['vehicleValuation'];
            values[formField.descuentoEspecial.name] = 0;
            setSaved(true)
            setIsCotizarDone2(true)
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            if (actions) actions.setSubmitting(false);
        })
    }

    function _handleSubmit(values, actions) {
        if (activeStep > 1) {
            _submitForm(values, actions);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    useEffect(() => {
        if (action === 'emitir') {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            } else {
                setFinalValues(nuevoInitialValues)
                _submitForm(nuevoInitialValues);
            }
        } else {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            }
        }
    }, [isCotizarDone2]);

    return (
			<React.Fragment>
				<div className={classes.formBox}>
					<>
						{isCotizarDone2 &&
							handlerEndCotizacion(finalValues, cotizacionResponse)}
					</>

					<div className={classes.iconCircle}>
						<img
							src={car_white_icon}
							alt='white_car_icon'
							style={{ width: '40px', height: 'auto' }}
						/>
					</div>
					<div style={{ margin: '24px 0' }}>
						<ProgressBar
							activeStep={activeStep}
							stepTitles={steps}
						/>
					</div>

					<Fragment>
						{activeStep > 2 ? (
							<Fragment>
								{isCotizarDone2
									? handlerEndCotizacion(finalValues, cotizacionResponse)
									: null}
							</Fragment>
						) : null}

						<Formik
							initialValues={
								cotizacionRetomada ? nuevoInitialValues : formInitialValues
							}
							validationSchema={currentValidationSchema}
							validateOnBlur={false}
							onSubmit={_handleSubmit}
						>
							{({ isSubmitting }) => (
								<Form id={formId}>
									{_renderStepContent(
										activeStep,
										marcas,
										setMarcas,
										modelos,
										setModelos,
										anios,
										setAnios,
										cotizacionRetomada,
										vehicleDetails,
										cotizacionResponse,
										props.setDescuentoEspecial,
									)}
									<div className={classes.buttons}>
										{activeStep !== 0 && (
											<Button
												onClick={_handleBack}
												variant='contained'
												className={classes.backButton}
												disabled={isSubmitting}
											>
												Atras
											</Button>
										)}
										<Button
											disabled={isSubmitting}
											type='submit'
											variant='contained'
											color='primary'
											className={classes.buttonContained}
										>
											{activeStep > 1 ? 'Solicitar cotización' : 'Siguiente'}
										</Button>
										{isSubmitting && (
											<CircularProgress
												size={24}
												className={classes.buttonProgress}
											/>
										)}
									</div>
								</Form>
							)}
						</Formik>
					</Fragment>
				</div>
			</React.Fragment>
		);
}
